import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="music" routeLang="es" />;

export const Route = createFileRoute("/musica-para-tu-local")({
  head: () => publicToolHead("music", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});